import React from "react";
const FormInput = ({style, placeholder,intype,event,name,value}) => {
    return (
        <input class={style} value={value} type={intype}  placeholder={placeholder}/>
    )
}
export default FormInput;

